import React from 'react'
import {
    Box,
    Button,
    Container,
    Heading,
    HStack,
    Icon,
    Text,
    VStack,
    useColorModeValue,
} from '@chakra-ui/react'
import { MdLock } from 'react-icons/md'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Forbidden = () => {
    const { t } = useTranslation()
    const tr = (key, defaultValue) => t(key, { defaultValue })
    const navigate = useNavigate()
    const location = useLocation()
    const state = location.state || {}
    const message = state.message || tr('forbidden.defaultMessage', "You don't have permission to access this resource.")
    const cardBg = useColorModeValue('white', 'navy.800')
    const titleColor = useColorModeValue('gray.700', 'white')
    const messageColor = useColorModeValue('gray.600', 'gray.300')

    return (
        <Container maxW="3xl" py={8} mt={20}>
            <Box bg={cardBg} shadow="md" borderRadius="md" p={10} textAlign="center">
                <VStack spacing={5}>
                    <Icon as={MdLock} boxSize={16} color="red.400" />
                    <Heading as="h1" size="xl">403</Heading>
                    <Heading as="h2" size="md" color={titleColor}>
                        {tr('forbidden.title', 'Access forbidden')}
                    </Heading>
                    <Text color={messageColor} maxW="md">
                        {message}
                    </Text>
                    {state.from && (
                        <Text fontSize="sm" color="gray.400">
                            {tr('forbidden.requested', 'Requested')}: {state.from}
                        </Text>
                    )}
                    <HStack spacing={3} pt={2}>
                        <Button variant="outline" onClick={() => navigate(-1)}>
                            {tr('forbidden.goBack', 'Go back')}
                        </Button>
                        <Button colorScheme="blue" onClick={() => navigate('/admin/default')}>
                            {tr('forbidden.goDashboard', 'Go to dashboard')}
                        </Button>
                    </HStack>
                </VStack>
            </Box>
        </Container>
    )
}

export default Forbidden
